export default __webpack_public_path__ + "static/media/logo.c33d38dd.png";